
import React from "react";
import { Button } from "./button";

interface LayoutLoaderProps {
  message?: string;
  error?: string;
  onRetry?: () => void;
}

export function LayoutLoader({ 
  message = "Loading...", 
  error, 
  onRetry 
}: LayoutLoaderProps) {
  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh]">
        <div className="text-destructive text-xl">⚠️ {error}</div>
        {onRetry && (
          <Button 
            className="mt-4" 
            variant="outline" 
            onClick={onRetry}
          >
            Retry
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh]">
      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary"></div>
      <p className="mt-4 text-lg text-muted-foreground">{message}</p>
    </div>
  );
}
